// Singleton in-memory cache of the SSDC doctor directory, keyed by id.
// Mirrors lib/employees.js. Backed by /api/doctors (which proxies Xano).
import { useEffect, useState } from 'react'

let cached = null   // Promise<{ list: Doctor[], byId: Map<id, Doctor> }>

export function loadDoctors() {
  if (cached) return cached
  cached = fetch('/api/doctors', { credentials: 'include' })
    .then(async (r) => {
      if (!r.ok) {
        const txt = await r.text().catch(() => '')
        throw new Error(`/api/doctors ${r.status}: ${txt.slice(0, 160)}`)
      }
      return r.json()
    })
    .then((arr) => {
      const list = Array.isArray(arr) ? arr : []
      const byId = new Map(list.map((d) => [Number(d.id), d]))
      return { list, byId }
    })
    .catch((err) => {
      // Don't cache failure — next caller retries instead of getting a stale empty list.
      cached = null
      console.error('[loadDoctors] failed:', err.message)
      throw err
    })
  return cached
}

/** React hook — returns `{ list, byId }` (or null while loading). */
export function useDoctors() {
  const [state, setState] = useState(null)
  useEffect(() => {
    let cancelled = false
    loadDoctors()
      .then((s) => { if (!cancelled) setState(s) })
      .catch(() => { if (!cancelled) setState({ list: [], byId: new Map() }) })
    return () => { cancelled = true }
  }, [])
  return state
}

export function doctorLabel(state, id) {
  if (!id) return null
  if (!state) return '…'
  const d = state.byId.get(Number(id))
  return d?.code || 'unknown'
}

export function doctorRecord(state, id) {
  if (!state || !id) return null
  return state.byId.get(Number(id)) || null
}
